import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ufolog } from '@atlassian/ufo-experimental/logger';
import { SUBSCRIBE_ALL, UFOGlobalEventStreamEventType } from '@atlassian/ufo-experimental/types';
export var UFOGlobalEventStream = /*#__PURE__*/function () {
  function UFOGlobalEventStream() {
    _classCallCheck(this, UFOGlobalEventStream);
    _defineProperty(this, "__buffer_only__", false);
    _defineProperty(this, "subscribers", {});
  }
  return _createClass(UFOGlobalEventStream, [{
    key: "push",
    value: function push(event) {
      ufolog('EVENT STREAM push', event.type, event.payload);
      if (event.type === UFOGlobalEventStreamEventType.EXPERIENCE_PAYLOAD) {
        this.publish(event.payload);
      }
      if (event.type === UFOGlobalEventStreamEventType.SUBSCRIBE) {
        this.subscribe(event.payload.experienceId, event.payload.callback);
      }
      if (event.type === UFOGlobalEventStreamEventType.UNSUBSCRIBE) {
        this.unsubscribe(event.payload.experienceId, event.payload.callback);
      }
    }
  }, {
    key: "publish",
    value: function publish(eventPayload) {
      var _this$subscribers$eve;
      if (this.subscribers[SUBSCRIBE_ALL]) {
        this.subscribers[SUBSCRIBE_ALL].forEach(function (fn) {
          fn(eventPayload);
        });
      }
      (_this$subscribers$eve = this.subscribers[eventPayload.id]) === null || _this$subscribers$eve === void 0 || _this$subscribers$eve.forEach(function (fn) {
        fn(eventPayload);
      });
    }
  }, {
    key: "subscribe",
    value: function subscribe(experienceId, fn) {
      ufolog('EVENT STREAM subscribe', experienceId);
      if (!this.subscribers[experienceId]) {
        this.subscribers[experienceId] = [];
      }
      this.subscribers[experienceId].push(fn);
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(experienceId, fn) {
      var index = this.subscribers[experienceId].findIndex(function (entry) {
        return entry === fn;
      });
      if (index !== -1) {
        this.subscribers[experienceId].splice(index, 1);
      }
    }
  }]);
}();